import { FC, useContext } from 'react';
import { context as StateContext } from '../context/state';
import { context as DependencyContext } from '../context/dependency';
import Page from '../page/PreviewCommentPage';

type Props = { className?: string };

const PreviewCommentPage: FC<Props> = ({ className }) => {
  const state = useContext(StateContext);
  const dependency = useContext(DependencyContext);

  return (
    <Page
      organization={state.lastAccessedOrganization.item}
      createPagePreview={dependency.previewCommentUsecase.createPagePreview}
      createdPreviewId={state.createdPreviewId.data}
      createdPreviewIdLoading={state.createdPreviewId.fetching > 0}
      onMount={() => {
        dependency.previewCommentUsecase.getPreviewPages();
      }}
      notifyUnimportant={dependency.messageDispatcher.notifyUnimportant}
      pagePreviews={state.pagePreviews.data}
      pagePreviewsLoading={state.pagePreviews.fetching > 0}
      className={className}
    />
  );
};

export default PreviewCommentPage;
